var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA20D1D7-E9D5-412E-9252-A807B12C9C55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Acreto-Commit-Screen-Open",
    transform: "translate(-1159.000000, -48.000000)",
    stroke: "#76888F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1159.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "commit-icon",
    transform: "translate(0.750100, 0.565300)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    strokeLinejoin: "round",
    points: "8.2499 14.4567 11.6999 11.4347 15.2989 14.4657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7499,12.4347 L11.7499,23.4347",
    id: "Stroke-2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.226,17.53 C20.714,17.53 23.541,14.703 23.541,11.216 C23.541,7.728 20.714,4.901 17.226,4.901 C17.165,4.901 17.105,4.908 17.045,4.91 C16.096,2.059 13.411,-1.42108547e-14 10.241,-1.42108547e-14 C6.278,-1.42108547e-14 3.066,3.213 3.066,7.175 C3.066,7.435 3.081,7.692 3.109,7.946 C1.287,8.684 -3.71258579e-13,10.468 -3.71258579e-13,12.555 C-3.71258579e-13,15.303 2.227,17.53 4.975,17.53 L6.001,17.53",
    id: "Stroke-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitIcon);
export default __webpack_public_path__ + "static/media/commit-icon.cd5001498d5c6cf52b1c1dbc8681c2d2.svg";
export { ForwardRef as ReactComponent };